module.exports = "<go-wrapper [title]=\"'Тэги'\"\n            [document]=\"document\"\n            [componentType]=\"componentType\">\n  <nv-tags [document]=\"document\"\n           [propertyName]=\"GO_COMPONENTS.TAGS\"></nv-tags>\n\n</go-wrapper>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/go/go-tags/go-tags.component.html
// module id = ../../../../../src/app/components/go/go-tags/go-tags.component.html
// module chunks = 0